import React from 'react';
import { FormOutlined } from '@ant-design/icons';
import SITELINKS from 'constants/sitelinks';
import { Link } from 'react-router-dom';
import { theme, Tooltip } from 'antd';

export default function DuplicatePackageButton({ packet }: any) {
  const { token } = theme.useToken();
  return (
    <Tooltip title="Duplicar paquete">
      <Link
        to={{
          pathname: `${SITELINKS.packages.send}`,
          state: { id: packet.id },
        }}
        aria-label="Duplicar paquete"
      >
        <FormOutlined style={{ color: token.colorPrimary, fontSize: 18 }} />
      </Link>
    </Tooltip>
  );
}
